import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import cleaningImage from '../../assets/images/cleaning-crew.jpg';

const Hero = () => {
  const phoneNumber = '561-674-6458';
  const navigate = useNavigate();

  const handleCallButtonClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleRequestServiceClick = () => {
    navigate('/request-service');
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="slogan">Too busy to clean?<br/>We can do it for you.</h1>
        <p className="subtitle">Weekly | Bi-weekly | Monthly | One-Time Cleaning Services</p>
        <div className='button-group'>
          <button className="cta-button primary" onClick={handleCallButtonClick}>
            Call Us
          </button>
          <button className="cta-button secondary" onClick={handleRequestServiceClick}>
            Request Service
          </button>
        </div>
      </div>
      <div className="hero-image">
        <img src={cleaningImage} alt="Cleaning" />
      </div>
    </section>
  );
};

export default Hero;
